import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();
  return (
    // <div className="main-content">
    //   <div className="main-card">
        <div className="home-content">
          <div className="home-main-section">
          <div className="home-right">
              <div className="home-tag" style={{ position : 'absolute',right:'19vh' }}> 
                <span>Care That's Truly<br />Tailored To You</span>
              </div>
              <div className="image-placeholder">
                <img src="/assets/home-img.svg" alt="Home illustration" className="home-image" />
              </div>
              <div className="home-tag" style={{ position : 'absolute',top:'26vh' }}>
                <span>Confidential &<br />Judgment-Free.</span>
              </div>
            </div>
            <div className="home-left">
              <h1 className="home-title">
                Struggling?<br />
                <span className="home-title-span">Compassionate Psychiatric<br />Support is Within Reach.</span>
              </h1>
              <p className="home-text">
                It's okay to admit you're struggling, and it's even braver to seek help. Predimind Connect makes it easy and confidential to connect with experienced, certified Indian psychiatric doctors from the comfort of your home. We're here to provide expert guidance, understanding, and a clear path forward, tailored to your specific needs.
              </p>
              <button
                onClick={() => navigate('/book')}
                className="home-book-button"
              >
                Book a call
              </button>
            </div>
            
          </div>
          {/* <div className="home-footer">
            <button
              onClick={() => navigate('/contact')}
              className="home-contact-button"
            >
              Contact Us
            </button>
          </div> */}
        </div>
    //   </div>
    // </div>
  );
};

export default HomePage; 